import { jsx as o, jsxs as l, Fragment as m } from "react/jsx-runtime";
import { useContext as P } from "react";
import { useTranslation as $ } from "react-i18next";
import "../../components/Breadcrumbs/index.js";
import j from "../../components/Button/index.js";
import "classnames";
import "reactjs-popup";
import y from "../../icons/Edit.js";
import { ThemeContext as z } from "../../components/ThemeContext/index.js";
import "../../modal-l0sNRNKZ.js";
import "../../fields/Input/index.js";
import "../../components/Tooltip/index.js";
import "../../fields/FieldContainer/index.js";
import "../../fields/Checkbox/index.js";
import "../../fields/ContentEditable/index.js";
import "../../fields/DateInput/index.js";
import "date-fns";
import "../../fields/Select/index.js";
import "react-dropzone";
import "react-dom";
import "../../fields/InputTooltip/index.js";
import "../../fields/PhoneInput/index.js";
import "../../fields/SocialSelect/index.js";
import f from "../../fields/Switcher/index.js";
import "../../fields/Textarea/index.js";
import "../../fields/Wysiwyg/index.js";
import I from "../FillGroup/index.js";
import M from "./FillProductsTable/index.js";
import O from "./FillProductsTable/FillProductsTableButtons/index.js";
import { useProductSelection as Vt } from "./useProductSelection.js";
const E = "forma-ui__fill-products__root", G = "forma-ui__fill-products__countLabel", U = "forma-ui__fill-products__info", q = "forma-ui__fill-products__sendingText", D = "forma-ui__fill-products__buttons", H = "forma-ui__fill-products__buttonAdd", J = "forma-ui__fill-products__switcher", K = "forma-ui__fill-products__vatSwitch", Q = "forma-ui__fill-products__headButton", n = {
  root: E,
  countLabel: G,
  info: U,
  sendingText: q,
  buttons: D,
  buttonAdd: H,
  switcher: J,
  vatSwitch: K,
  headButton: Q
}, R = ["VAT"], W = ["totalVAT", "periodTotalVAT"], St = ({
  data: r,
  products: i,
  productsTotal: h,
  customProductsIds: b,
  showSelect: c,
  selected: a,
  onSelect: d,
  actions: u,
  changes: T,
  excludeVAT: g,
  onChangeExcludeVat: k
}) => {
  const { name: x, columns: _, total: p } = r, { t: e } = $(), { viewport: C } = P(z), { onClickAdd: s, onClickImport: w, onClickAddSection: v, onClickAddManual: A } = u, S = x ?? e("uikit:products_and_services"), B = c && d, N = c && a, V = i.filter(({ type: t }) => t !== "title").length, F = !!(i != null && i.length), L = _.find(({ id: t }) => R.includes(t)) || p.find(({ id: t }) => W.includes(t));
  return /* @__PURE__ */ o(
    I,
    {
      title: S,
      buttons: /* @__PURE__ */ l(m, { children: [
        B && /* @__PURE__ */ o(
          f,
          {
            containerClass: n.switcher,
            name: `checkbox_${r.id}`,
            label: C !== "phone" && e("uikit:select_block"),
            size: "small",
            onChange: (t) => d(t.target.checked),
            checked: a
          }
        ),
        !c && /* @__PURE__ */ l(m, { children: [
          /* @__PURE__ */ l("span", { children: [
            V,
            " ",
            e("uikit:pcs")
          ] }),
          s && /* @__PURE__ */ o(
            j,
            {
              viewStyle: "text",
              className: n.headButton,
              icon: /* @__PURE__ */ o(y, {}),
              onClick: () => s(i.length - 1)
            }
          )
        ] })
      ] }),
      children: N ? /* @__PURE__ */ o("div", { className: n.sendingText, children: e("uikit:sending_to_filling") }) : /* @__PURE__ */ o("div", { className: n.content, children: F ? /* @__PURE__ */ l(m, { children: [
        L && /* @__PURE__ */ o(
          f,
          {
            id: `exclude_vat_${r.id}`,
            name: `exclude_vat_${r.id}`,
            label: e("uikit:exclude_vat"),
            checked: g,
            containerClass: n.vatSwitch,
            onChange: (t) => k(t.target.checked),
            size: "small"
          }
        ),
        /* @__PURE__ */ o(
          M,
          {
            products: i,
            productsTotal: h,
            columns: _,
            total: p,
            customProductsIds: b,
            actions: u,
            changes: T
          }
        )
      ] }) : /* @__PURE__ */ o(
        O,
        {
          index: i.length - 1,
          onClickAdd: s,
          onClickImport: w,
          onClickAddSection: v,
          onClickAddManual: A,
          className: n.buttons
        }
      ) })
    }
  );
};
export {
  St as default,
  Vt as useProductSelection
};
